import orderBy from 'lodash/orderBy';
import { SERVICE_FEE_RATE } from '@/core/fantasySelection/fantasySelectionConfig';
import { i18n } from '@/core/lib/i18n';
import { getTranslatedName } from '@/core/lib/translationHelper';
import type { IFantasySelectionContest, IPool } from '@/interface/IFantasySelection';
import { FantasySelectionBetStatus } from '@/interface/enum';
import { useCustomerStore } from '@/store/customerStore';

export function getEntriesDisplay(maxEntries: number, currentEntries: number) {
    return maxEntries === 0 ? `${currentEntries}` : `${currentEntries}/${maxEntries}`;
}

function getTotalPrizePool(pool: IPool) {
    if (pool.currentEntries < 2) {
        return pool.entryFee * 2 * (1 - SERVICE_FEE_RATE);
    }
    return pool.prizePool;
}

export function getTotalPrizePoolDisplay(pool: IPool) {
    const { formatMoneyWithSymbolAndDecimal } = useCustomerStore();
    return formatMoneyWithSymbolAndDecimal(getTotalPrizePool(pool));
}

export function getEntryFeeDisplay(pool: IPool) {
    const { formatMoneyWithSymbolAndDecimal } = useCustomerStore();
    return formatMoneyWithSymbolAndDecimal(pool.entryFee);
}

export function getLeagueNames(contest: IFantasySelectionContest) {
    const leagueNames = contest.leagues.map(league => getTranslatedName(league.names));
    return getLeagueNamesDisplay(leagueNames);
}

export function getTotalEntries(contest: IFantasySelectionContest) {
    return contest.pools.reduce((acc, pool) => acc + (pool.currentEntries ?? 0), 0);
}

export function getLeagueNamesDisplay(leagues: string[]) {
    return leagues.length > 1 ? `${i18n.t('fantasy_selection_mixed_leagues')} ${leagues.join(', ')}` : leagues[0];
}

export function getOrderedPools(pools: IPool[]) {
    return orderBy(pools, ['maxEntries', 'entryFee'], ['asc', 'desc']);
}

export function isShowPrizePool(status: FantasySelectionBetStatus) {
    return status === FantasySelectionBetStatus.Running || status === FantasySelectionBetStatus.Won;
}
